<div id="fuse-shortcuts" #shortcuts>

  @if (!mobileShortcutsPanelActive) {
    <div class="shortcuts-mobile-toggle" fxLayout="row" fxLayoutAlign="start center"
      fxHide fxShow.lt-md>
      <button mat-icon-button (click)="showMobileShortcutsPanel()">
        <mat-icon class="amber-600-fg">star</mat-icon>
      </button>
    </div>
  }

  <div class="shortcuts" fxHide fxShow.gt-sm>

    <div fxLayout="row" fxLayoutAlign="space-between center" fxFlex="0 1 auto">

      <div fxLayout="row" fxLayoutAlign="start center">

        @for (shortcutItem of shortcutItems; track shortcutItem) {
          <div class="w-40 h-40 p-4" fxLayout="row" fxLayoutAlign="center center"
            >
            <a mat-icon-button matTooltip="{{shortcutItem.title}}" [routerLink]="shortcutItem.url">
              @if (shortcutItem.icon) {
                <mat-icon class="secondary-text">{{shortcutItem.icon}}</mat-icon>
              }
              @if (!shortcutItem.icon) {
                <span class="h2 secondary-text text-bold">
                  {{shortcutItem.title.substr(0, 1).toUpperCase()}}
                </span>
              }
            </a>
          </div>
        }

        <button mat-icon-button [matMenuTriggerFor]="addMenu" matTooltip="Click to add/remove shortcut"
          (menuOpened)="onMenuOpen()">
          <mat-icon class="amber-600-fg">star</mat-icon>
        </button>

      </div>

      <div class="shortcuts-mobile-close" fxLayout="row" fxLayoutAlign="start center" fxHide fxShow.lt-md>
        <button mat-icon-button (click)="hideMobileShortcutsPanel()">
          <mat-icon svgIcon="cross" class="type-icon"></mat-icon>
        </button>
      </div>

    </div>

    <mat-menu #addMenu="matMenu" class="w-240">

      <mat-form-field class="px-16 w-100-p" (click)="$event.stopPropagation()" floatLabel="never">
        <mat-label>Search for an app or a page</mat-label><input #searchInput matInput  (input)="search($event)">
      </mat-form-field>

      <mat-divider></mat-divider>

      @if (!searching) {
        <mat-nav-list style="max-height: 312px; overflow: auto" fusePerfectScrollbar>
          @for (shortcutItem of shortcutItems; track shortcutItem) {
            <mat-list-item
              (click)="toggleShortcut($event, shortcutItem)">
              <div class="w-100-p" fxLayout="row" fxLayoutAlign="start center">
                @if (shortcutItem.icon) {
                  <mat-icon mat-list-icon class="mr-8 secondary-text">
                    {{shortcutItem.icon}}
                  </mat-icon>
                }
                @if (!shortcutItem.icon) {
                  <span class="h2 w-32 h-32 p-4 mr-8 secondary-text text-bold" fxLayout="row"
                    fxLayoutAlign="center center">
                    {{shortcutItem.title.substr(0, 1).toUpperCase()}}
                  </span>
                }
                <p matListItemLine fxFlex>{{shortcutItem.title}}</p>
                <mat-icon class="ml-8 amber-fg">star</mat-icon>
              </div>
            </mat-list-item>
          }
          @if (shortcutItems.length === 0) {
            <mat-list-item>
              <p>
                <small>No shortcuts yet!</small>
              </p>
            </mat-list-item>
          }
        </mat-nav-list>
      }

      @if (searching) {
        <mat-nav-list style="max-height: 312px; overflow: auto" fusePerfectScrollbar>
          @for (navigationItem of filteredNavigationItems; track navigationItem) {
            <mat-list-item
              (click)="toggleShortcut($event, navigationItem)">
              <div class="w-100-p" fxLayout="row" fxLayoutAlign="start center">
                @if (navigationItem.icon) {
                  <mat-icon mat-list-icon class="mr-8 secondary-text">
                    {{navigationItem.icon}}
                  </mat-icon>
                }
                @if (!navigationItem.icon) {
                  <span class="h2 w-32 h-32 p-4 mr-8 secondary-text text-bold" fxLayout="row"
                    fxLayoutAlign="center center">
                    {{navigationItem.title.substr(0, 1).toUpperCase()}}
                  </span>
                }
                <p matListItemLine fxFlex>{{navigationItem.title}}</p>
                @if (isInShortcuts(navigationItem)) {
                  <mat-icon class="ml-8 amber-fg">star</mat-icon>
                }
              </div>
            </mat-list-item>
          }
        </mat-nav-list>
      }

    </mat-menu>

  </div>

</div>